/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'wwg-view-json-dialog',
  templateUrl: './view-json-dialog.component.html',
  styleUrls: ['./view-json-dialog.component.scss']
})
export class ViewJsonDialogComponent {

  public json: any;

  constructor(
    public dialogRef: MatDialogRef<ViewJsonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.json = JSON.stringify(data, null, 4);
  }
}
